import { render, staticRenderFns } from "./widgetReview.vue?vue&type=template&id=3cbdeb91&scoped=true"
import script from "./widgetReview.vue?vue&type=script&lang=js"
export * from "./widgetReview.vue?vue&type=script&lang=js"
import style0 from "./widgetReview.vue?vue&type=style&index=0&id=3cbdeb91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbdeb91",
  null
  
)

export default component.exports